// Colors        https://colorbrewer2.org/#type=qualitative&scheme=Paired&n=8
export const ResidentialColor: string = "#1f78b4"; //2
export const SMEColor: string = "#b2df8a"; //3
export const LargeColor: string = "#fb9a99"; //6
export const InactiveColor: string = '#111';
export const GraphBackgroundColor: string = '#f3f3f3';
export const BaseLineColor: string = "#000000"
export const GraphLineColor: string = "#e0e0e0"
export const Line2020Color: string = "#A62190";
export const Line2019Color: string = "#4760DE";
export const AnnotationLineColor: string = "#cc5f43";
export const AnnotationFillColor: string = "#5ba966";
export const BaseColor: string = "#000000";
export const ThemeColor: string = "#3f51b5"


export type MarketType = 'Residential' | 'Commercial' | 'Large';
export type Regions = "Regional" | "Metropolitan";
export type DataFilters = "Markets" | "2019"


export type SettingChoices = "YoYTotal" | "YoYMarketRegion" | "Intro" | "RawYearComparison" | "Calendar"
export const StepList: SettingChoices[] = ["Intro", "RawYearComparison", "YoYTotal", "YoYMarketRegion", "Calendar"]
export const StepOrder: { [key: number]: SettingChoices } = {
    0: "Intro",
    1: "RawYearComparison",
    2: "YoYTotal",
    3: "YoYMarketRegion",
    4: "Calendar"
}
export const StoryLims = {
    "Intro": 3,
    "RawYearComparison": 2,
    "YoYTotal": 3,
    "YoYMarketRegion": 2,
    "Calendar": 1
}
export const StepTranslations = { "Intro": "Introduction", "RawYearComparison": "Consumption Between Years", "YoYTotal": "Year on Year Change", "YoYMarketRegion": "Regional Changes", "YoYMarket": "Market Type Changes", "Calendar": "Day Changes" }



export type Month = "January" | "February" | "March" | "April" | "May" | "June" | "July" | "August" | "September" | "October" | "November" | "December"
export const MonthMap = {
    January: 0,
    February: 1,
    March: 2,
    April: 3,
    May: 4,
    June: 5,
    July: 6,
    August: 7,
    September: 8,
    October: 9,
    November: 10,
    December: 11
};